import React from "react";
import { Checkbox } from "@graffer-inc/console-design-kit";

type Props = {
  value: boolean;
  disabled?: boolean;
  onChange: () => void;
};

export const SurveySearchEngineSetting: React.FC<Props> = ({
  value,
  disabled,
  onChange,
}) => {
  return (
    <div className="field">
      <Checkbox
        label={"検索エンジンでの表示設定"}
        description={
          "アンケートを、Googleなどの検索結果に表示しないようにできます。"
        }
        options={[
          {
            name: "検索エンジンの結果ページに表示しないようにする",
            value: "searchEngineSettings",
          },
        ]}
        values={value ? ["searchEngineSettings"] : []}
        onChange={() => {
          onChange();
        }}
        disabled={disabled}
      />
    </div>
  );
};
